<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'
// components
import SiteHeaderContainer from '@Widgets/Headers/SiteHeaderContainer.vue'
// async components
const HeaderLegacy = defineAsyncComponent(() => import('@Widgets/Headers/HeaderLegacy.vue'))

defineOptions({
  name: 'TheHeader',
})

// The redesigned header (GRWT-544) rolls out site-wide, while /help-center and
// /help-center/* keep the legacy header until the help-center redesign lands.
// Route-based (not layout-based): help-center pages are split across both layouts.
const route = useRoute()

const refIsHelpCenter = computed<boolean>(() => route.path.startsWith('/help-center'))
</script>

<template>
  <HeaderLegacy v-if="refIsHelpCenter" />
  <SiteHeaderContainer v-else />
</template>
